<mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 1000]"
               [pageSize]="paginationData().pageSize"
               [pageIndex]="paginationData().pageNumber! - 1"
               [length]="paginationData().total"
               (page)="handlePageEvent($event)" showFirstLastButtons>
</mat-paginator>
